import { SlidersHorizontal } from "lucide-react";
import { cn } from "@/lib/utils";

interface FilterButtonProps {
  /** Active filters; a badge shows when above zero. */
  count: number;
  onClick: () => void;
  /** Accessible name, e.g. "Filter issues". */
  label: string;
  className?: string;
}

/**
 * The title-row button that opens a page's filter sheet where no filter
 * sidebar shows. Issues and Photos share it so filters open from the same
 * corner, looking the same. See [[filter-button.spec]].
 */
export function FilterButton({ count, onClick, label, className }: FilterButtonProps) {
  return (
    <button
      type="button"
      data-slot="filter-button"
      onClick={onClick}
      aria-label={label}
      className={cn(
        "relative flex h-9 w-9 items-center justify-center",
        className,
      )}
    >
      <SlidersHorizontal className="h-5 w-5" />
      {count > 0 && (
        <span className="absolute right-0 top-1 flex h-4 min-w-4 items-center justify-center rounded-full bg-tertiary px-1 text-[9px] font-semibold text-tertiary-foreground">
          {count}
        </span>
      )}
    </button>
  );
}
